<template>
    <v-layout justify-center class="container fluid azul--text">
        <v-flex md8>
            <h1 class="pl-8 ml-8 pt-3 mt-3">Quienes somos</h1>
            <v-container>
                <v-row>
                    <v-col cols="12" lg="6" xl="6">
                        <h3 class="py-2 my-2">
                            Droguería Ciafarma
                        </h3>
                        <p>
                            Somos una empresa familiar de servicios comerciales
                            y logísticos de especialidades medicinales y
                            nutricionales de laboratorios de 1era línea, fundada
                            en marzo de 1996.
                        </p>
                        <p>
                            Gracias a la confianza y solidez de nuestro equipo
                            de trabajo , clientes y proveedores, en 2012 nos
                            mudamos a Alvarez Condarco 327 Bis ( a 1Km
                            Aeropuerto Rosario), un punto estratégico para la
                            logística hacia toda la zona centro y norte del pais
                            que atendemos.
                        </p>
                        <p>
                            Nuestro objetivo es
                            <b>brindar soluciones integrales</b>
                            para las farmacias e instituciones como socios
                            estratégicos de
                            <b>laboratorios de primeras marcas</b>
                            en nuestra región.
                        </p>
                    </v-col>
                    <v-col cols="12" lg="6" xl="6">
                        <v-img
                            :src="
                                require('../../public/img/about-view/mapa-ciafarma.png')
                            "
                            min-height="100%"
                        />
                    </v-col>
                </v-row>
                <v-divider class="azul"></v-divider>
                <v-row>
                    <v-col cols="12">
                        <h1 class="pl-8 ml-8 pt-3 mt-3">
                            Aspectos que nos caracterizan
                        </h1>
                    </v-col>
                </v-row>
                <v-row class="text-center">
                    <v-col cols="12" md="5" lg="5" xl="5" class="px-6 mx-6">
                        <h2 align="center">Misión</h2>
                        <p>
                            Somos un equipo comprometido y positivo que busca a
                            través de un trato personalizado y sincero, ayudar a
                            nuestros clientes a alcanzar sus metas eligiendo
                            nuestros productos basados en su calidad y seguridad
                        </p>
                    </v-col>
                    <v-col
                        cols="12"
                        md="5"
                        lg="5"
                        xl="5"
                        class="px-6 mx-6"
                        align="center"
                    >
                        <h2 align="center">Visión</h2>
                        <p>
                            Ser la droguería elegida por sus productos,
                            soluciones y servicios, reconocida por la calidad
                            humana y profesional de nuestra gente
                        </p>
                    </v-col>
                    <v-col>
                        <h2 align="center">
                            Valores
                        </h2>
                        <v-row>
                            <v-col
                                align="center"
                                cols="12"
                                sm="4"
                                md="4"
                                lg="4"
                                xl="4"
                            >
                                <p>
                                    <b>Trabajo en equipo</b>
                                    <br />
                                    Reunimos las aptitudes individuales,
                                    potenciando nuestro esfuerzo para aumentar
                                    la eficacia en los resultados.
                                </p>
                            </v-col>
                            <v-col
                                align="center"
                                cols="12"
                                sm="4"
                                md="4"
                                lg="4"
                                xl="4"
                            >
                                <p>
                                    <b>Compromiso</b>
                                    <br />
                                    Sacamos adelante aquello que se nos ha
                                    confiado aún en circunstancias
                                    desfavorables.
                                </p>
                            </v-col>
                            <v-col
                                align="center"
                                cols="12"
                                sm="4"
                                md="4"
                                lg="4"
                                xl="4"
                            >
                                <p>
                                    <b>Honestidad</b>
                                    <br />
                                    Somos coherentes entre lo que decimos y
                                    hacemos, demostrándolo en nuestras acciones.
                                </p>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    data: () => ({})
};
</script>
